
export class ChannelForDropdownModel  {
    channelListName?: string | null;
}

 
     
         
